import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var FOOCMask = function(param) {
    var _param_hide = param.hide, hide = _param_hide === void 0 ? false : _param_hide, children = param.children;
    return hide ? /*#__PURE__*/ _jsx("div", {
        className: "lapel-fooc-mask lapel-pass-through",
        children: children
    }) : children;
};
export { FOOCMask };

//# sourceMappingURL=FOOCMask.js.map